// extracted by mini-css-extract-plugin
module.exports = {"pagination-dropdown":"pagination-dropdown_pagination-dropdown__O_tQA","pagination-dropdown-block":"pagination-dropdown_pagination-dropdown-block__3ix-z"};